import type { ReactNode } from 'react';

interface Props {
  title: string;
  right?: ReactNode;
}

/** Sub-header strip used by Portfolio / Resume / Contact pages. */
export default function SubHeader({ title, right }: Props) {
  return (
    <div className="sub-header">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="pull-left">
              <h1>{title}</h1>
            </div>
            {right && <div className="pull-right">{right}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
